import { httpRequest } from "../../http";
import type { Discrepancy, ReportDiscrepancyPayload } from "@models/Discrepancy.model";

export class CommandReportDiscrepancy {
  async run(payload: ReportDiscrepancyPayload): Promise<Discrepancy> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/discrepancies/`;
    return httpRequest<Discrepancy, ReportDiscrepancyPayload>(url, { method: "POST", body: payload });
  }
}
